module.exports = __webpack_public_path__ + "img/tms.ce57f36d.jpg";